module.exports = {"SIGN_IN_SMS_CODE_EXPIRE_DATE":"expire_date","ERROR_MESSAGES":{"SMS_CODE":"sms_code.0","PHONE":"phone.0"},"SMS_ERROR_KEY":"sms_code"}


//////////////////
// WEBPACK FOOTER
// ./src/plugins/tfs/platformConfigs/integrationMaps/signin.json
// module id = 332
// module chunks = 1